import { ECommerceOnboarding } from "consts/ecommerce";
import type { ID } from "types";
import { route } from "util/support";

export const enum WebRouteTypes {
    Root = 'Root',
    Dashboard = 'Dashboard',
    Login = 'Login',
    ChangePassword = 'ChangePassword',
    Transactions = 'Transactions',
    Finance = 'Finance',
    Merchants = 'Merchants',
    Users = 'Users',
    Consumers = 'Consumers',
    Profile = 'Profile',
    Support = 'Support',
    PreApplication = 'PreApplication',
    Onboarding = 'Onboarding',
    ECommerce = 'ECommerce',
    PaymentMethods = 'PaymentMethods'
};

export const WebRoutes = {
    [WebRouteTypes.Root]: route(['']),
    [WebRouteTypes.ECommerce]: {
        Platforms: route(['ecommerce', 'platforms'])
    },
    [WebRouteTypes.Dashboard]: route(['dashboard']),
    [WebRouteTypes.Login]: {
        Index: route(['login']),
        Verify2FA: route(['login', 'verify-2fa']),
        SendResetLink: route(['login', 'send-reset-link'])
    },
    [WebRouteTypes.ChangePassword]: route(['change-password', ':token']),
    [WebRouteTypes.Transactions]: route(['transactions']),
    [WebRouteTypes.Merchants]: {
        Index: route(['merchants']),
        List: route(['merchants', 'list']),
        KYCSettings: {
            Index: route(['merchants', 'kyc-settings']),
            Merchant: (merchantId: ID) =>
                route(['merchants', 'kyc-settings', merchantId])
        },
        TicketingSystem: {
            Index: route(['merchants', 'ticketing-system']),
            Merchant: (merchantId: ID) =>
                route(['merchants', 'ticketing-system', merchantId])
        }
    },
    [WebRouteTypes.Finance]: {
        Index: route(['finance']),
        Settlements: route(['finance', 'settlements']),
        SummaryFiles: route(['finance', 'summary-files']),
    },
    [WebRouteTypes.Consumers]: {
        Index: route(['consumers']),
        WhiteListed: route(['consumers', 'whitelisted'])
    },
    [WebRouteTypes.Users]: route(['users']),
    [WebRouteTypes.Profile]: route(['profile']),
    [WebRouteTypes.Support]: route(['support']),
    [WebRouteTypes.PreApplication]: route(['pre-application']),
    [WebRouteTypes.Onboarding]: {
        Index: route(['onboarding']),
        Merchant: {
            Index: route(['onboarding', ECommerceOnboarding.Merchant]),
            Complete: route(['onboarding', ECommerceOnboarding.Merchant, 'complete'])
        },
        HighRiskMerchant: {
            Index: route(['onboarding', ECommerceOnboarding.HighRiskMerchant]),
            Complete: route(['onboarding', ECommerceOnboarding.HighRiskMerchant, 'complete'])
        }
    },
    [WebRouteTypes.PaymentMethods]: route(['payment-methods'])
};
